// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body, html {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    background-color: #f0f0f0; 
}

.main-container {
    width: 100%;
    height: calc(100vh - 80px); 
    display: flex;
    flex-direction: column;
    background-color: inherit; 
}
 
.fixed-header {

    left: 0;
    top: 8%;
    padding: 1rem; 
    
    font-size:22px;
}
.plant-header {
    font-size: 22px;
    width: 30vw; 
    margin: 0; 

} 


.main-div {
    padding: 1rem; 
    width: 35vw;
    margin-top: -1%; 
    border-radius: 20px;
}

.card-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr); 
    grid-template-rows: repeat(2, auto);    
    gap: 1rem; 
    justify-items: center;
    align-items: center;
}

.item {
    background-color: white;
    padding: 1rem; 
    text-align: center;
    width: 15vw; 
    min-height: 12vh; 
    border-radius: 20px;
    font-weight: bold;
    font-size: 17px;
}
.main-div2{
    padding: 1rem; 
    width: 47vw;
    margin-top: -1%; 
}
.main-div3{
    margin-top:-34%;
    width: 47vw;
    margin-left: 50%;  
}
.flow-diagram{
  margin-top:-18%;
  margin-left: 60%;
  width: 38vw;
  height:20vw;
  background-color: white;
}


.env-benefits{
  margin-top:-20%;
  margin-left: 36%;
  margin-bottom:14%;
   width: 22vw;
  height:9.2vw;
  background-color: rgb(203, 252, 236);
  border-radius: 15px;
  justify-content: center;
  text-align: center;
      
   }
   .environ-benefits{
    margin-top:-16%;
    margin-left: 36%;
    margin-bottom:6%;
     width: 22vw;
    height:12vw;
    background-color:white;
    border-radius: 15px;
    justify-content: center;
    text-align: center;
        
     }
     .env-header{
     font-size:18px;
     margin:5px;
    }
    
   .coal ,.co2, .ETP{
      font-size:10px;
      justify-content: center;
      text-align: center;
  }
  
  .values-row {
      display:flex;
      justify-content: center;
      text-align: center;
      gap: 50px; 
      margin-top:4px;
      font-weight: bold;
    
    }
    
    .text-row {
      display: flex;
      gap: 12px; 
      margin-top: 3px; 
      margin-left: 10px;
    }
    .text-row .co2{
      margin-left: 50px;
    }
    .text-row .ETP{
      margin-left: 34px;
    }
    .EB-image-row {
      display: flex;
      gap: 50px; 
      margin-left:10px;
    }
    
    .EB-image-row img {
      width: 40px;
      height: 40px;
      margin-left:10px;
    } 
  
  .alarm-div{
    margin-top:-10%;
    margin-left: 36%;
    width: 22vw;
    height:9vw;
    
    border-radius: 10px;
    justify-content: center;
    text-align: center;
    
  }
  .alarm-container {
    padding: 2px;
    border: 2px solid #ccc;
    border-radius: 10px;
    
  }
  
 
  .alarm-header h6 {
    font-size: 18px;
    font-weight: bold;
   
  }
  
  .alarm-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }
  
  .alarm-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  .alarm-item span {
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }
  
  .alarm-icon {
    width: 15px;
    height: 15px;
    margin-right: 8px;
  }
  
  .critical {
    background-color:white;
  }
  
  .day-graph1{
    width:100%;
    
  }

  .chart-container {
    width: 100%;
   
}
  
  .date-picker-container {
    display: flex;
    align-items: center;
    margin: 1rem 0;
}

.date-picker-label {
    font-weight: bold;
    margin-right: 1rem;
}

.styled-date-picker {
    padding: 0.5rem 1rem;
    font-size: 16px;
    border: 2px solid #ddd;
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    transition: border-color 0.3s, box-shadow 0.3s;
}

.styled-date-picker:hover {
    border-color: #999;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.styled-date-picker:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.dropdown-container{
    margin-top: 1px;
    
    
}
.styled-dropdown{
    height:38px;
    padding: 0.4rem 1rem;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
   
}
.date-picker-container,
.dropdown-container {
    display: inline-block;
    margin-right: 10px; 
}

.date-picker-dropdown-container {
    display: flex;
    align-items: center; 
}

.energy-value-container {
    display: flex;
    flex-direction: row; 
    align-items: center; 
    gap: 10px; 
    background-color: lightgray;
    margin-top:-1%;
}

.energy-value-container h6 {
    margin-left: 10%; 
    padding: 0;
    font-size: 16px; 
}

.energy-value-container .energy-label {

    font-weight: normal; 
    
}



@media only screen and (min-width: 1403px) {

  .plant-header {
    font-size: 24px;
    width: 30vw; 
    margin: 0; 

} 
  .item {
    background-color: white;
    padding: 1.2rem; 
    text-align: center;
    width: 15vw; 
    min-height: 13vh; 
    border-radius: 20px;
    font-weight: bold;
    font-size: 20px;
  }
  .main-div3 {
      margin-top: -31%; 
      width: 47vw; 
  }

  .EB-image-row {
    display: flex;
    gap: 58px; 
    margin-left:20px;
  }
  
  .EB-image-row img {
    width: 45px;
    height: 45px;
    margin-left:7px;
  }
  
  .date-picker-container {
    display: flex;
    align-items: center;
    margin: 1rem 0;
}

.date-picker-label {
    font-weight: bold;
    margin-right: 1rem;
}

.styled-date-picker {
    padding: 0.6rem 1.1rem;
    font-size: 17px;
    border: 2px solid #ddd;
    border-radius: 5px;
  }

.dropdown-container{
    margin-top: 1px;   
}
.styled-dropdown{
    height:38px;
    padding: 0.4rem 1rem;
    font-size: 17px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
   
}
.date-picker-container,
.dropdown-container {
    display: inline-block;
    margin-right: 10px; 
}
.energy-value-container {
    gap: 10px; 
    margin-top:-1%;
}

.energy-value-container h6 {
    margin-left: 10%; 
    padding: 0;
    font-size: 17px; 
}

}



@media only screen and (min-width: 1540px) {
  .plant-header {
    font-size: 26px;
    width: 30vw; 
    margin: 0; 

} 
  
.item {
  background-color: white;
  padding: 1rem; 
  text-align: center;
  width: 15vw; 
  min-height: 13vh; 
  border-radius: 21px;
  font-weight: bold;
  font-size: 22px;
}
  .main-div3 {
      margin-top: -27.5%; 
      width: 47vw; 
  }
  .flow-diagram{
    margin-top:-17%;
    margin-left: 60%;
    width: 38vw;
    height:20vw;
    background-color: white;
  }
  .env-benefits{
    margin-top:-20%;  
    border-radius: 18px;    
     }
     .env-header{
      font-size:22px;
    }
  .coal ,.co2, .ETP{
      font-size:13px;
      justify-content: center;
      text-align: center;
  }
  
  .values-row {
      display:flex;
      justify-content: center;
      text-align: center;
      gap: 64px; 
      margin-top:5px;
      font-weight: bold;
    
    }
    
    .text-row {
      display: flex;
      gap: 14px; 
      margin-top: 3px; 
      margin-left: 10px;
    }
    .text-row .co2{
      margin-left: 52px;
    }
    .text-row .ETP{
      margin-left: 38px;
    }
    .EB-image-row {
      display: flex;
      gap: 60px; 
      margin-left:20px;
    }
    
    .EB-image-row img {
      width: 50px;
      height: 50px;
      margin-left:10px;
    } 
    .alarm-div{
      margin-top:-10%;
      margin-left: 36%;
      width: 22vw;
      height:9vw;
      
      border-radius: 10px;
      justify-content: center;
      text-align: center;
      
    }
    .alarm-container {
      padding: 5px;
      border: 3px solid #ccc;
      border-radius: 10px;
      
    }
    
   
    .alarm-header h6 {
      font-size: 20px;
      font-weight: bold;
     
    }
    
    .alarm-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 18px;
    }
    
    .alarm-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 11px;
      border-radius: 8px;
      background-color: white;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
    
    .alarm-item span {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
    
    .alarm-icon {
      width: 15px;
      height: 15px;
      margin-right: 8px;
    }


    .date-picker-container {
      display: flex;
      align-items: center;
      margin: 1rem 0;
  }
  
  .date-picker-label {
      font-weight: bold;
      margin-right: 1rem;
  }
  
  .styled-date-picker {
      padding: 0.7rem 1.2rem;
      font-size: 19px;
      border: 2px solid #ddd;
      border-radius: 6px;
    }
  
  .dropdown-container{
      margin-top: 1px;   
  }
  .styled-dropdown{
      height:46px;
      padding: 0.5rem 1rem;
      font-size: 19px;
      border: 1px solid #ddd;
      border-radius: 6px;
      background-color: white;
      cursor: pointer;
     
  }
  .date-picker-container,
  .dropdown-container {
      display: inline-block;
      margin-right: 10px; 
  }
  .energy-value-container {
      gap: 10px; 
      margin-top:-1%;
  }
  
  .energy-value-container h6 {
      margin-left: 10%; 
      padding: 1;
      font-size: 19px; 
  }
}

@media only screen and (min-width: 1684px) {
  
  .plant-header {
    font-size: 28px;
    width: 30vw; 
    margin: 0; 
} 
.main-div {
  padding: 1.2rem; 
  width: 35vw;
  margin-top: -1%; 
  border-radius: 20px;
}
.item {
    background-color: white;
    padding: 1rem; 
    text-align: center;
    width: 15vw; 
    min-height: 13vh; 
    border-radius: 20px;
    font-weight: bold;
    font-size: 24px;
}

.main-div3 {
  margin-top: -29.5%; 
  width: 47vw; 
}

.env-benefits{
  margin-top:-20%; 
  border-radius: 20px;     
   }
.coal ,.co2, .ETP{
    font-size:14px;
    justify-content: center;
    text-align: center;
}

.values-row {
    display:flex;
    justify-content: center;
    text-align: center;
    gap: 60px; 
    margin-top:5px;
    font-weight: bold;
  
  }
  
  .text-row {
    display: flex;
    gap: 14px; 
    margin-top: 3px; 
    margin-left: 10px;
  }
  .text-row .co2{
    margin-left: 60px;
  }
  .text-row .ETP{
    margin-left: 38px;
  }
  .EB-image-row {
    display: flex;
    gap: 64px; 
    margin-left:20px;
  }
  
  .EB-image-row img {
    width: 52px;
    height: 50px;
    margin-left:10px;
  } 
  .alarm-div{
    margin-top:-10%;
    margin-left: 36%;
    width: 22vw;
    height:9vw;
    
    border-radius: 12px;
    justify-content: center;
    text-align: center;
    
  }
  .alarm-container {
    padding: 3px;
    border: 3px solid #ccc;
    border-radius: 10px;
    
  }
  
 
  .alarm-header h6 {
    font-size: 21px;
    font-weight: bold;
   
  }
  
  .alarm-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 18px;
  }
  
  .alarm-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    border-radius: 9px;
    background-color: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  .alarm-item span {
    font-size: 19px;
    font-weight: bold;
    color: #333;
  }
  
  .alarm-icon {
    width: 17px;
    height: 17px;
    margin-right: 9px;
  }

  .date-picker-container {
    display: flex;
    align-items: center;
    margin: 1rem 0;
}

.date-picker-label {
    font-weight: bold;
    margin-right: 1rem;
}

.styled-date-picker {
    padding: 0.7rem 1.2rem;
    font-size: 22px;
    border: 2px solid #ddd;
    border-radius: 7px;
  }

.dropdown-container{
    margin-top: 1px;   
}
.styled-dropdown{
    height:53px;
    padding: 0.5rem 1rem;
    font-size: 22px;
    border: 2px solid #ddd;
    border-radius: 7px;
    background-color: white;
    cursor: pointer;
   
}
.date-picker-container,
.dropdown-container {
    display: inline-block;
    margin-right: 10px; 
}
.energy-value-container {
    gap: 10px; 
    margin-top:-1%;
}

.energy-value-container h6 {
    margin-left: 10%; 
    padding: 1;
    font-size: 22px; 
}

}

@media only screen and (min-width: 1874px) {

  .plant-header {
    font-size: 29px;
    width: 30vw; 
    margin: 0; 
} 
.main-div {
  padding: 1.2rem; 
  width: 35vw;
  margin-top: -1%; 
  border-radius: 20px;
}
.item {
    background-color: white;
    padding: 1rem; 
    text-align: center;
    width: 15vw; 
    min-height: 13vh; 
    border-radius: 20px;
    font-weight: bold;
    font-size: 25px;
}
  .main-div3 {
      margin-top: -31.5%; 
      width: 47vw; 
    
  }
  .flow-diagram{
    margin-top:-16%;
    margin-left: 60%;
    width: 38vw;
    height:20vw;
    background-color: white;
  }
  .env-benefits{
    margin-top:-25%;  
    border-radius: 22px;
       
     }
  .coal ,.co2, .ETP{
      font-size:17px;
      justify-content: center;
      text-align: center;
  }
  .env-header{
    font-size:24px;
  }
  
  .values-row {
      display:flex;
      justify-content: center;
      text-align: center;
      gap: 60px; 
      margin-top:5px;
      font-weight: bold;
    
    }
    
    .text-row {
      display: flex;
      gap: 12px; 
      margin-top: 3px; 
      margin-left: 10px;
    }
    .text-row .co2{
      margin-left: 58px;
    }
    .text-row .ETP{
      margin-left: 34px;
    }
    .EB-image-row {
      display: flex;
      gap: 65px; 
      margin-left:20px;
    }
    
    .EB-image-row img {
      width: 58px;
      height: 56px;
      margin-left:12px;
    } 

    .alarm-div{
      margin-top:-10%;
      margin-left: 36%;
      width: 22vw;
      height:14vw;
      border-radius: 10px;
      justify-content: center;
      text-align: center; 
    } 
    
    .alarm-container {
      padding: 10px;
      border: 3px solid #ccc;
      border-radius: 10px;
      
    }
    
   
    .alarm-header h6 {
      font-size: 24px;
      font-weight: bold;
     
    }
    
    .alarm-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
    }
    
    .alarm-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px;
      border-radius: 9px;
      background-color: white;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
    
    .alarm-item span {
      font-size: 21px;
      font-weight: bold;
      color: #333;
    }
    
    .alarm-icon {
      width: 17px;
      height: 17px;
      margin-right: 8px;
    }
    .date-picker-container {
      display: flex;
      align-items: center;
      margin: 1rem 0;
  }
  
  .date-picker-label {
      font-weight: bold;
      margin-right: 1rem;
  }
  
  .styled-date-picker {
      padding: 0.7rem 1.2rem;
      font-size: 22px;
      border: 2px solid #ddd;
      border-radius: 7px;
    }
  
  .dropdown-container{
      margin-top: 1px;   
  }
  .styled-dropdown{
      height:53px;
      padding: 0.5rem 1rem;
      font-size: 22px;
      border: 2px solid #ddd;
      border-radius: 7px;
      background-color: white;
      cursor: pointer;
     
  }
  .date-picker-container,
  .dropdown-container {
      display: inline-block;
      margin-right: 10px; 
  }
  .energy-value-container {
      gap: 10px; 
      margin-top:-1%;
  }
  
  .energy-value-container h6 {
      margin-left: 10%; 
      padding: 1;
      font-size: 23px; 
  }
     
}

@media only screen and (min-width: 2530px) {
  .plant-header {
    font-size: 41px;
    width: 30vw; 
    margin: 3; 
} 
.main-div {
  padding: 1.6rem; 
  width: 35vw;
  margin-top: -1%; 
  border-radius: 20px;
}
.item {
    background-color: white;
    padding: 1rem; 
    text-align: center;
    width: 15vw; 
    min-height: 13vh; 
    border-radius: 22px;
    font-weight: bold;
    font-size: 34px;
}
  .main-div3 {
      margin-top: -27.5%; 
      width: 47vw; 
      
  }
  .flow-diagram{
    margin-top:-15%;
    margin-left: 60%;
    width: 38vw;
    height:20vw;
    background-color: white;
  }
  .env-benefits{
    margin-top:-28%; 
    border-radius: 24px; 
       
     }
  .coal ,.co2, .ETP{
      font-size:24px;
      justify-content: center;
      text-align: center;
  }
  .env-header{
    font-size:30px;
  }
  
  .values-row {
      display:flex;
      justify-content: center;
      text-align: center;
      gap: 66px; 
      margin-top:12px;
      font-weight: bold;
    
    }
    
    .text-row {
      display: flex;
      gap: 15px; 
      margin-top: 3px; 
      margin-left: 10px;
    }
    .text-row .co2{
      margin-left: 72px;
    }
    .text-row .ETP{
      margin-left: 34px;
    }
    .EB-image-row {
      display: flex;
      gap: 94px; 
      margin-left:20px;
    }
    
    .EB-image-row img {
      width: 78px;
      height: 76px;
      margin-left:14px;
    } 

    .alarm-div{
      margin-top:-11%;
      margin-left: 36%;
      width: 22vw;
      height:18vw;
      
      border-radius: 12px;
      justify-content: center;
      text-align: center;
      
    }
    .alarm-container {
      padding: 15px;
      border: 4px solid #ccc;
      border-radius: 12px;
      
    }
    
   
    .alarm-header h6 {
      font-size: 34px;
      font-weight: bold;
     
    }
    .alarm-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 27px;
    }
    
    .alarm-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px;
      border-radius: 8px;
      background-color: white;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
    
    .alarm-item span {
      font-size: 28px;
      font-weight: bold;
      color: #333;
    }
    
    .alarm-icon {
      width: 18px;
      height: 18px;
      margin-right: 8px;
    }
    .date-picker-container {
      display: flex;
      align-items: center;
      margin: 1rem 0;
  }
  
  .date-picker-label {
      font-weight: bold;
      margin-right: 1rem;
  }
  
  .styled-date-picker {
      padding: 0.8rem 1.3rem;
      font-size: 32px;
      border: 3px solid #ddd;
      border-radius: 10px;
    }
  
  .dropdown-container{
      margin-top: 1px;   
  }
  .styled-dropdown{
      height:70px;
      padding: 0.5rem 1rem;
      font-size: 32px;
      border: 3px solid #ddd;
      border-radius: 8px;
      background-color: white;
      cursor: pointer;
     
  }
  .date-picker-container,
  .dropdown-container {
      display: inline-block;
      margin-right: 10px; 
  }
  .energy-value-container {
      gap: 10px; 
      margin-top:0.1%;
  }
  
  .energy-value-container h6 {
      margin-left: 10%; 
      padding: 1;
      font-size: 33px; 
  }
}

@media only screen and (min-width: 3796px) {

  .plant-header {
    font-size:62px;
    width: 30vw; 
    margin: 15; 
} 
.main-div {
  padding: 1.6rem; 
  width: 35vw;
  margin-top: 0.8%; 
  border-radius: 24px;
}
.item {
    background-color: white;
    padding: 2rem; 
    text-align: center;
    width: 15vw; 
    min-height: 13vh; 
    border-radius: 32px;
    font-weight: bold;
    font-size: 52px;
}
  .main-div3 {
      margin-top: -26%; 
      width: 47vw; 
      
  }
  .flow-diagram{
    margin-top:-14%;
    margin-left: 60%;
    width: 38vw;
    height:20vw;
    background-color: white;
  }
  .env-benefits{
    margin-top:-26%;  
    width: 22vw;
    height:10vw; 
    border-radius: 27px;   
     }
  .coal ,.co2, .ETP{
      font-size:37px;
      justify-content: center;
      text-align: center;
  }
  .env-header{
    font-size:44px;
  }
  
  .values-row {
      display:flex;
      justify-content: center;
      text-align: center;
      gap: 85px; 
      margin-top:18px;
      font-weight: bold;
    
    }
    
    .text-row {
      display: flex;
      gap: 28px; 
      margin-top: 3px; 
      margin-left: 10px;
    }
    .text-row .co2{
      margin-left: 100px;
    }
    .text-row .ETP{
      margin-left: 34px;
    }
    .EB-image-row {
      display: flex;
      gap: 140px; 
      margin-left:20px;
    }
    
    .EB-image-row img {
      width: 128px;
      height: 116px;
      margin-left:28px;
    } 

    .alarm-div{
      margin-top:-10%;
      margin-left: 36%;
      width: 22vw;
      height:15vw;
      border-radius: 10px;
      justify-content: center;
      text-align: center;
      
    }
    .alarm-container {
      padding: 25px;
      border: 6px solid #ccc;
      border-radius: 15px;
      
    }
    
   
    .alarm-header h6 {
      font-size: 46px;
      font-weight: bold;
     
    }
    .alarm-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 28px;
    }
    
    .alarm-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 30px;
      border-radius: 22px;
      background-color: white;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
    
    .alarm-item span {
      font-size: 45px;
      font-weight: bold;
      color: #333;
    }
    
    .alarm-icon {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
    .date-picker-container {
      display: flex;
      align-items: center;
      margin: 1rem 0;
  }
  
  .date-picker-label {
      font-weight: bold;
      margin-right: 1rem;
  }
  
  .styled-date-picker {
      padding: 1.2rem 1.7rem;
      font-size: 47px;
      border: 5px solid #ddd;
      border-radius: 14px;
    }
  
  .dropdown-container{
      margin-top: 1px;   
  }
  .styled-dropdown{
      height:94px;
      padding: 0.6rem 1.2rem;
      font-size: 48px;
      border: 3px solid #ddd;
      border-radius: 8px;
      background-color: white;
      cursor: pointer;
     
  }
  .date-picker-container,
  .dropdown-container {
      display: inline-block;
      margin-right: 10px; 
  }
  .energy-value-container {
      gap: 10px; 
      margin-top:0.1%;
  }
  
  .energy-value-container h6 {
      margin-left: 10%; 
      padding: 1;
      font-size: 47px; 
  }  
}


@media only screen and (min-width: 5061px) {
  .plant-header {
    font-size:80px;
    width: 30vw; 
    margin: 15; 
} 
.main-div {
  padding: 1.6rem; 
  width: 35vw;
  margin-top: 1%; 
  border-radius: 28px;
}
.item {
    background-color: white;
    padding: 2rem; 
    text-align: center;
    width: 15vw; 
    min-height: 13vh; 
    border-radius: 32px;
    font-weight: bold;
    font-size: 70px;
}

  .main-div3 {
      margin-top: -23.8%; 
      width: 47vw; 
      height: 300px !important;
      
  }
  .flow-diagram{
    margin-top:-15%;
    margin-left: 60%;
    width: 38vw;
    height:20vw;
    background-color: white;
  }
  .env-benefits{
    margin-top:-28%;  
    width: 22vw;
    height:10vw;   
    border-radius: 34px;  
     }
  .coal ,.co2, .ETP{
      font-size:45px;
      justify-content: center;
      text-align: center;
  }
  .env-header{
    font-size:58px;
    margin:25px;
  }
  
  .values-row {
      display:flex;
      justify-content: center;
      text-align: center;
      gap: 150px; 
      margin-top:20px;
      font-weight: bold;
    
    }
    
    .text-row {
      display: flex;
      gap: 38px; 
      margin-top: 3px; 
      margin-left: 10px;
    }
    .text-row .co2{
      margin-left: 130px;
    }
    .text-row .ETP{
      margin-left: 34px;
    }
    .EB-image-row {
      display: flex;
      gap: 220px; 
      margin-left:38px;
    }
    
    .EB-image-row img {
      width: 158px;
      height: 146px;
      margin-left:28px;
    } 

    .alarm-div{
      margin-top:-9%;
      margin-left: 36%;
      width: 22vw;
      height:16vw;
      border-radius: 16px;
      justify-content: center;
      text-align: center;
      
    }
    .alarm-container {
      padding: 40px;
      border: 8px solid #ccc;
      border-radius: 32px;
      
    }
    
   
    .alarm-header h6 {
      font-size: 65px;
      font-weight: bold;
     
    }
    .alarm-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 28px;
    }
    
    .alarm-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 32px;
      border-radius: 18px;
      background-color: white;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
    
    .alarm-item span {
      font-size: 58px;
      font-weight: bold;
      color: #333;
    }
    
    .alarm-icon {
      width: 38px;
      height: 38px;
      margin-right: 18px;
    }
    .date-picker-container {
      display: flex;
      align-items: center;
      margin: 1rem 0;
  }
  
  .date-picker-label {
      font-weight: bold;
      margin-right: 1rem;
  }
  
  .styled-date-picker {
      padding: 1.3rem 1.8rem;
      font-size: 65px;
      border: 5px solid #ddd;
      border-radius: 14px;
    }
  
  .dropdown-container{
      margin-top: 1px;   
  }
  .styled-dropdown{
      height:125px;
      padding: 0.6rem 1.2rem;
      font-size: 65px;
      border: 3px solid #ddd;
      border-radius: 8px;
      background-color: white;
      cursor: pointer;
     
  }
  .date-picker-container,
  .dropdown-container {
      display: inline-block;
      margin-right: 10px; 
  }
  .energy-value-container {
      gap: 10px; 
      margin-top:0.1%;
  }
  
  .energy-value-container h6 {
      margin-left: 10%; 
      padding: 1;
      font-size: 67px; 
  } 

}




 */
`, "",{"version":3,"sources":["webpack://./src/components/Overview/OverviewStyle.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA27CE","sourcesContent":["/* body, html {\r\n    margin: 0;\r\n    padding: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: #f0f0f0; \r\n}\r\n\r\n.main-container {\r\n    width: 100%;\r\n    height: calc(100vh - 80px); \r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: inherit; \r\n}\r\n \r\n.fixed-header {\r\n\r\n    left: 0;\r\n    top: 8%;\r\n    padding: 1rem; \r\n    \r\n    font-size:22px;\r\n}\r\n.plant-header {\r\n    font-size: 22px;\r\n    width: 30vw; \r\n    margin: 0; \r\n\r\n} \r\n\r\n\r\n.main-div {\r\n    padding: 1rem; \r\n    width: 35vw;\r\n    margin-top: -1%; \r\n    border-radius: 20px;\r\n}\r\n\r\n.card-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr); \r\n    grid-template-rows: repeat(2, auto);    \r\n    gap: 1rem; \r\n    justify-items: center;\r\n    align-items: center;\r\n}\r\n\r\n.item {\r\n    background-color: white;\r\n    padding: 1rem; \r\n    text-align: center;\r\n    width: 15vw; \r\n    min-height: 12vh; \r\n    border-radius: 20px;\r\n    font-weight: bold;\r\n    font-size: 17px;\r\n}\r\n.main-div2{\r\n    padding: 1rem; \r\n    width: 47vw;\r\n    margin-top: -1%; \r\n}\r\n.main-div3{\r\n    margin-top:-34%;\r\n    width: 47vw;\r\n    margin-left: 50%;  \r\n}\r\n.flow-diagram{\r\n  margin-top:-18%;\r\n  margin-left: 60%;\r\n  width: 38vw;\r\n  height:20vw;\r\n  background-color: white;\r\n}\r\n\r\n\r\n.env-benefits{\r\n  margin-top:-20%;\r\n  margin-left: 36%;\r\n  margin-bottom:14%;\r\n   width: 22vw;\r\n  height:9.2vw;\r\n  background-color: rgb(203, 252, 236);\r\n  border-radius: 15px;\r\n  justify-content: center;\r\n  text-align: center;\r\n      \r\n   }\r\n   .environ-benefits{\r\n    margin-top:-16%;\r\n    margin-left: 36%;\r\n    margin-bottom:6%;\r\n     width: 22vw;\r\n    height:12vw;\r\n    background-color:white;\r\n    border-radius: 15px;\r\n    justify-content: center;\r\n    text-align: center;\r\n        \r\n     }\r\n     .env-header{\r\n     font-size:18px;\r\n     margin:5px;\r\n    }\r\n    \r\n   .coal ,.co2, .ETP{\r\n      font-size:10px;\r\n      justify-content: center;\r\n      text-align: center;\r\n  }\r\n  \r\n  .values-row {\r\n      display:flex;\r\n      justify-content: center;\r\n      text-align: center;\r\n      gap: 50px; \r\n      margin-top:4px;\r\n      font-weight: bold;\r\n    \r\n    }\r\n    \r\n    .text-row {\r\n      display: flex;\r\n      gap: 12px; \r\n      margin-top: 3px; \r\n      margin-left: 10px;\r\n    }\r\n    .text-row .co2{\r\n      margin-left: 50px;\r\n    }\r\n    .text-row .ETP{\r\n      margin-left: 34px;\r\n    }\r\n    .EB-image-row {\r\n      display: flex;\r\n      gap: 50px; \r\n      margin-left:10px;\r\n    }\r\n    \r\n    .EB-image-row img {\r\n      width: 40px;\r\n      height: 40px;\r\n      margin-left:10px;\r\n    } \r\n  \r\n  .alarm-div{\r\n    margin-top:-10%;\r\n    margin-left: 36%;\r\n    width: 22vw;\r\n    height:9vw;\r\n    \r\n    border-radius: 10px;\r\n    justify-content: center;\r\n    text-align: center;\r\n    \r\n  }\r\n  .alarm-container {\r\n    padding: 2px;\r\n    border: 2px solid #ccc;\r\n    border-radius: 10px;\r\n    \r\n  }\r\n  \r\n \r\n  .alarm-header h6 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n   \r\n  }\r\n  \r\n  .alarm-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .alarm-item {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    background-color: white;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .alarm-item span {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    color: #333;\r\n  }\r\n  \r\n  .alarm-icon {\r\n    width: 15px;\r\n    height: 15px;\r\n    margin-right: 8px;\r\n  }\r\n  \r\n  .critical {\r\n    background-color:white;\r\n  }\r\n  \r\n  .day-graph1{\r\n    width:100%;\r\n    \r\n  }\r\n\r\n  .chart-container {\r\n    width: 100%;\r\n   \r\n}\r\n  \r\n  .date-picker-container {\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 1rem 0;\r\n}\r\n\r\n.date-picker-label {\r\n    font-weight: bold;\r\n    margin-right: 1rem;\r\n}\r\n\r\n.styled-date-picker {\r\n    padding: 0.5rem 1rem;\r\n    font-size: 16px;\r\n    border: 2px solid #ddd;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n    cursor: pointer;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    transition: border-color 0.3s, box-shadow 0.3s;\r\n}\r\n\r\n.styled-date-picker:hover {\r\n    border-color: #999;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.styled-date-picker:focus {\r\n    outline: none;\r\n    border-color: #007bff;\r\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\r\n}\r\n\r\n.dropdown-container{\r\n    margin-top: 1px;\r\n    \r\n    \r\n}\r\n.styled-dropdown{\r\n    height:38px;\r\n    padding: 0.4rem 1rem;\r\n    font-size: 16px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n    cursor: pointer;\r\n   \r\n}\r\n.date-picker-container,\r\n.dropdown-container {\r\n    display: inline-block;\r\n    margin-right: 10px; \r\n}\r\n\r\n.date-picker-dropdown-container {\r\n    display: flex;\r\n    align-items: center; \r\n}\r\n\r\n.energy-value-container {\r\n    display: flex;\r\n    flex-direction: row; \r\n    align-items: center; \r\n    gap: 10px; \r\n    background-color: lightgray;\r\n    margin-top:-1%;\r\n}\r\n\r\n.energy-value-container h6 {\r\n    margin-left: 10%; \r\n    padding: 0;\r\n    font-size: 16px; \r\n}\r\n\r\n.energy-value-container .energy-label {\r\n\r\n    font-weight: normal; \r\n    \r\n}\r\n\r\n\r\n\r\n@media only screen and (min-width: 1403px) {\r\n\r\n  .plant-header {\r\n    font-size: 24px;\r\n    width: 30vw; \r\n    margin: 0; \r\n\r\n} \r\n  .item {\r\n    background-color: white;\r\n    padding: 1.2rem; \r\n    text-align: center;\r\n    width: 15vw; \r\n    min-height: 13vh; \r\n    border-radius: 20px;\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n  }\r\n  .main-div3 {\r\n      margin-top: -31%; \r\n      width: 47vw; \r\n  }\r\n\r\n  .EB-image-row {\r\n    display: flex;\r\n    gap: 58px; \r\n    margin-left:20px;\r\n  }\r\n  \r\n  .EB-image-row img {\r\n    width: 45px;\r\n    height: 45px;\r\n    margin-left:7px;\r\n  }\r\n  \r\n  .date-picker-container {\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 1rem 0;\r\n}\r\n\r\n.date-picker-label {\r\n    font-weight: bold;\r\n    margin-right: 1rem;\r\n}\r\n\r\n.styled-date-picker {\r\n    padding: 0.6rem 1.1rem;\r\n    font-size: 17px;\r\n    border: 2px solid #ddd;\r\n    border-radius: 5px;\r\n  }\r\n\r\n.dropdown-container{\r\n    margin-top: 1px;   \r\n}\r\n.styled-dropdown{\r\n    height:38px;\r\n    padding: 0.4rem 1rem;\r\n    font-size: 17px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n    cursor: pointer;\r\n   \r\n}\r\n.date-picker-container,\r\n.dropdown-container {\r\n    display: inline-block;\r\n    margin-right: 10px; \r\n}\r\n.energy-value-container {\r\n    gap: 10px; \r\n    margin-top:-1%;\r\n}\r\n\r\n.energy-value-container h6 {\r\n    margin-left: 10%; \r\n    padding: 0;\r\n    font-size: 17px; \r\n}\r\n\r\n}\r\n\r\n\r\n\r\n@media only screen and (min-width: 1540px) {\r\n  .plant-header {\r\n    font-size: 26px;\r\n    width: 30vw; \r\n    margin: 0; \r\n\r\n} \r\n  \r\n.item {\r\n  background-color: white;\r\n  padding: 1rem; \r\n  text-align: center;\r\n  width: 15vw; \r\n  min-height: 13vh; \r\n  border-radius: 21px;\r\n  font-weight: bold;\r\n  font-size: 22px;\r\n}\r\n  .main-div3 {\r\n      margin-top: -27.5%; \r\n      width: 47vw; \r\n  }\r\n  .flow-diagram{\r\n    margin-top:-17%;\r\n    margin-left: 60%;\r\n    width: 38vw;\r\n    height:20vw;\r\n    background-color: white;\r\n  }\r\n  .env-benefits{\r\n    margin-top:-20%;  \r\n    border-radius: 18px;    \r\n     }\r\n     .env-header{\r\n      font-size:22px;\r\n    }\r\n  .coal ,.co2, .ETP{\r\n      font-size:13px;\r\n      justify-content: center;\r\n      text-align: center;\r\n  }\r\n  \r\n  .values-row {\r\n      display:flex;\r\n      justify-content: center;\r\n      text-align: center;\r\n      gap: 64px; \r\n      margin-top:5px;\r\n      font-weight: bold;\r\n    \r\n    }\r\n    \r\n    .text-row {\r\n      display: flex;\r\n      gap: 14px; \r\n      margin-top: 3px; \r\n      margin-left: 10px;\r\n    }\r\n    .text-row .co2{\r\n      margin-left: 52px;\r\n    }\r\n    .text-row .ETP{\r\n      margin-left: 38px;\r\n    }\r\n    .EB-image-row {\r\n      display: flex;\r\n      gap: 60px; \r\n      margin-left:20px;\r\n    }\r\n    \r\n    .EB-image-row img {\r\n      width: 50px;\r\n      height: 50px;\r\n      margin-left:10px;\r\n    } \r\n    .alarm-div{\r\n      margin-top:-10%;\r\n      margin-left: 36%;\r\n      width: 22vw;\r\n      height:9vw;\r\n      \r\n      border-radius: 10px;\r\n      justify-content: center;\r\n      text-align: center;\r\n      \r\n    }\r\n    .alarm-container {\r\n      padding: 5px;\r\n      border: 3px solid #ccc;\r\n      border-radius: 10px;\r\n      \r\n    }\r\n    \r\n   \r\n    .alarm-header h6 {\r\n      font-size: 20px;\r\n      font-weight: bold;\r\n     \r\n    }\r\n    \r\n    .alarm-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 18px;\r\n    }\r\n    \r\n    .alarm-item {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      padding: 11px;\r\n      border-radius: 8px;\r\n      background-color: white;\r\n      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    }\r\n    \r\n    .alarm-item span {\r\n      font-size: 18px;\r\n      font-weight: bold;\r\n      color: #333;\r\n    }\r\n    \r\n    .alarm-icon {\r\n      width: 15px;\r\n      height: 15px;\r\n      margin-right: 8px;\r\n    }\r\n\r\n\r\n    .date-picker-container {\r\n      display: flex;\r\n      align-items: center;\r\n      margin: 1rem 0;\r\n  }\r\n  \r\n  .date-picker-label {\r\n      font-weight: bold;\r\n      margin-right: 1rem;\r\n  }\r\n  \r\n  .styled-date-picker {\r\n      padding: 0.7rem 1.2rem;\r\n      font-size: 19px;\r\n      border: 2px solid #ddd;\r\n      border-radius: 6px;\r\n    }\r\n  \r\n  .dropdown-container{\r\n      margin-top: 1px;   \r\n  }\r\n  .styled-dropdown{\r\n      height:46px;\r\n      padding: 0.5rem 1rem;\r\n      font-size: 19px;\r\n      border: 1px solid #ddd;\r\n      border-radius: 6px;\r\n      background-color: white;\r\n      cursor: pointer;\r\n     \r\n  }\r\n  .date-picker-container,\r\n  .dropdown-container {\r\n      display: inline-block;\r\n      margin-right: 10px; \r\n  }\r\n  .energy-value-container {\r\n      gap: 10px; \r\n      margin-top:-1%;\r\n  }\r\n  \r\n  .energy-value-container h6 {\r\n      margin-left: 10%; \r\n      padding: 1;\r\n      font-size: 19px; \r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 1684px) {\r\n  \r\n  .plant-header {\r\n    font-size: 28px;\r\n    width: 30vw; \r\n    margin: 0; \r\n} \r\n.main-div {\r\n  padding: 1.2rem; \r\n  width: 35vw;\r\n  margin-top: -1%; \r\n  border-radius: 20px;\r\n}\r\n.item {\r\n    background-color: white;\r\n    padding: 1rem; \r\n    text-align: center;\r\n    width: 15vw; \r\n    min-height: 13vh; \r\n    border-radius: 20px;\r\n    font-weight: bold;\r\n    font-size: 24px;\r\n}\r\n\r\n.main-div3 {\r\n  margin-top: -29.5%; \r\n  width: 47vw; \r\n}\r\n\r\n.env-benefits{\r\n  margin-top:-20%; \r\n  border-radius: 20px;     \r\n   }\r\n.coal ,.co2, .ETP{\r\n    font-size:14px;\r\n    justify-content: center;\r\n    text-align: center;\r\n}\r\n\r\n.values-row {\r\n    display:flex;\r\n    justify-content: center;\r\n    text-align: center;\r\n    gap: 60px; \r\n    margin-top:5px;\r\n    font-weight: bold;\r\n  \r\n  }\r\n  \r\n  .text-row {\r\n    display: flex;\r\n    gap: 14px; \r\n    margin-top: 3px; \r\n    margin-left: 10px;\r\n  }\r\n  .text-row .co2{\r\n    margin-left: 60px;\r\n  }\r\n  .text-row .ETP{\r\n    margin-left: 38px;\r\n  }\r\n  .EB-image-row {\r\n    display: flex;\r\n    gap: 64px; \r\n    margin-left:20px;\r\n  }\r\n  \r\n  .EB-image-row img {\r\n    width: 52px;\r\n    height: 50px;\r\n    margin-left:10px;\r\n  } \r\n  .alarm-div{\r\n    margin-top:-10%;\r\n    margin-left: 36%;\r\n    width: 22vw;\r\n    height:9vw;\r\n    \r\n    border-radius: 12px;\r\n    justify-content: center;\r\n    text-align: center;\r\n    \r\n  }\r\n  .alarm-container {\r\n    padding: 3px;\r\n    border: 3px solid #ccc;\r\n    border-radius: 10px;\r\n    \r\n  }\r\n  \r\n \r\n  .alarm-header h6 {\r\n    font-size: 21px;\r\n    font-weight: bold;\r\n   \r\n  }\r\n  \r\n  .alarm-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 18px;\r\n  }\r\n  \r\n  .alarm-item {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 12px;\r\n    border-radius: 9px;\r\n    background-color: white;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .alarm-item span {\r\n    font-size: 19px;\r\n    font-weight: bold;\r\n    color: #333;\r\n  }\r\n  \r\n  .alarm-icon {\r\n    width: 17px;\r\n    height: 17px;\r\n    margin-right: 9px;\r\n  }\r\n\r\n  .date-picker-container {\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 1rem 0;\r\n}\r\n\r\n.date-picker-label {\r\n    font-weight: bold;\r\n    margin-right: 1rem;\r\n}\r\n\r\n.styled-date-picker {\r\n    padding: 0.7rem 1.2rem;\r\n    font-size: 22px;\r\n    border: 2px solid #ddd;\r\n    border-radius: 7px;\r\n  }\r\n\r\n.dropdown-container{\r\n    margin-top: 1px;   \r\n}\r\n.styled-dropdown{\r\n    height:53px;\r\n    padding: 0.5rem 1rem;\r\n    font-size: 22px;\r\n    border: 2px solid #ddd;\r\n    border-radius: 7px;\r\n    background-color: white;\r\n    cursor: pointer;\r\n   \r\n}\r\n.date-picker-container,\r\n.dropdown-container {\r\n    display: inline-block;\r\n    margin-right: 10px; \r\n}\r\n.energy-value-container {\r\n    gap: 10px; \r\n    margin-top:-1%;\r\n}\r\n\r\n.energy-value-container h6 {\r\n    margin-left: 10%; \r\n    padding: 1;\r\n    font-size: 22px; \r\n}\r\n\r\n}\r\n\r\n@media only screen and (min-width: 1874px) {\r\n\r\n  .plant-header {\r\n    font-size: 29px;\r\n    width: 30vw; \r\n    margin: 0; \r\n} \r\n.main-div {\r\n  padding: 1.2rem; \r\n  width: 35vw;\r\n  margin-top: -1%; \r\n  border-radius: 20px;\r\n}\r\n.item {\r\n    background-color: white;\r\n    padding: 1rem; \r\n    text-align: center;\r\n    width: 15vw; \r\n    min-height: 13vh; \r\n    border-radius: 20px;\r\n    font-weight: bold;\r\n    font-size: 25px;\r\n}\r\n  .main-div3 {\r\n      margin-top: -31.5%; \r\n      width: 47vw; \r\n    \r\n  }\r\n  .flow-diagram{\r\n    margin-top:-16%;\r\n    margin-left: 60%;\r\n    width: 38vw;\r\n    height:20vw;\r\n    background-color: white;\r\n  }\r\n  .env-benefits{\r\n    margin-top:-25%;  \r\n    border-radius: 22px;\r\n       \r\n     }\r\n  .coal ,.co2, .ETP{\r\n      font-size:17px;\r\n      justify-content: center;\r\n      text-align: center;\r\n  }\r\n  .env-header{\r\n    font-size:24px;\r\n  }\r\n  \r\n  .values-row {\r\n      display:flex;\r\n      justify-content: center;\r\n      text-align: center;\r\n      gap: 60px; \r\n      margin-top:5px;\r\n      font-weight: bold;\r\n    \r\n    }\r\n    \r\n    .text-row {\r\n      display: flex;\r\n      gap: 12px; \r\n      margin-top: 3px; \r\n      margin-left: 10px;\r\n    }\r\n    .text-row .co2{\r\n      margin-left: 58px;\r\n    }\r\n    .text-row .ETP{\r\n      margin-left: 34px;\r\n    }\r\n    .EB-image-row {\r\n      display: flex;\r\n      gap: 65px; \r\n      margin-left:20px;\r\n    }\r\n    \r\n    .EB-image-row img {\r\n      width: 58px;\r\n      height: 56px;\r\n      margin-left:12px;\r\n    } \r\n\r\n    .alarm-div{\r\n      margin-top:-10%;\r\n      margin-left: 36%;\r\n      width: 22vw;\r\n      height:14vw;\r\n      border-radius: 10px;\r\n      justify-content: center;\r\n      text-align: center; \r\n    } \r\n    \r\n    .alarm-container {\r\n      padding: 10px;\r\n      border: 3px solid #ccc;\r\n      border-radius: 10px;\r\n      \r\n    }\r\n    \r\n   \r\n    .alarm-header h6 {\r\n      font-size: 24px;\r\n      font-weight: bold;\r\n     \r\n    }\r\n    \r\n    .alarm-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 24px;\r\n    }\r\n    \r\n    .alarm-item {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      padding: 14px;\r\n      border-radius: 9px;\r\n      background-color: white;\r\n      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    }\r\n    \r\n    .alarm-item span {\r\n      font-size: 21px;\r\n      font-weight: bold;\r\n      color: #333;\r\n    }\r\n    \r\n    .alarm-icon {\r\n      width: 17px;\r\n      height: 17px;\r\n      margin-right: 8px;\r\n    }\r\n    .date-picker-container {\r\n      display: flex;\r\n      align-items: center;\r\n      margin: 1rem 0;\r\n  }\r\n  \r\n  .date-picker-label {\r\n      font-weight: bold;\r\n      margin-right: 1rem;\r\n  }\r\n  \r\n  .styled-date-picker {\r\n      padding: 0.7rem 1.2rem;\r\n      font-size: 22px;\r\n      border: 2px solid #ddd;\r\n      border-radius: 7px;\r\n    }\r\n  \r\n  .dropdown-container{\r\n      margin-top: 1px;   \r\n  }\r\n  .styled-dropdown{\r\n      height:53px;\r\n      padding: 0.5rem 1rem;\r\n      font-size: 22px;\r\n      border: 2px solid #ddd;\r\n      border-radius: 7px;\r\n      background-color: white;\r\n      cursor: pointer;\r\n     \r\n  }\r\n  .date-picker-container,\r\n  .dropdown-container {\r\n      display: inline-block;\r\n      margin-right: 10px; \r\n  }\r\n  .energy-value-container {\r\n      gap: 10px; \r\n      margin-top:-1%;\r\n  }\r\n  \r\n  .energy-value-container h6 {\r\n      margin-left: 10%; \r\n      padding: 1;\r\n      font-size: 23px; \r\n  }\r\n     \r\n}\r\n\r\n@media only screen and (min-width: 2530px) {\r\n  .plant-header {\r\n    font-size: 41px;\r\n    width: 30vw; \r\n    margin: 3; \r\n} \r\n.main-div {\r\n  padding: 1.6rem; \r\n  width: 35vw;\r\n  margin-top: -1%; \r\n  border-radius: 20px;\r\n}\r\n.item {\r\n    background-color: white;\r\n    padding: 1rem; \r\n    text-align: center;\r\n    width: 15vw; \r\n    min-height: 13vh; \r\n    border-radius: 22px;\r\n    font-weight: bold;\r\n    font-size: 34px;\r\n}\r\n  .main-div3 {\r\n      margin-top: -27.5%; \r\n      width: 47vw; \r\n      \r\n  }\r\n  .flow-diagram{\r\n    margin-top:-15%;\r\n    margin-left: 60%;\r\n    width: 38vw;\r\n    height:20vw;\r\n    background-color: white;\r\n  }\r\n  .env-benefits{\r\n    margin-top:-28%; \r\n    border-radius: 24px; \r\n       \r\n     }\r\n  .coal ,.co2, .ETP{\r\n      font-size:24px;\r\n      justify-content: center;\r\n      text-align: center;\r\n  }\r\n  .env-header{\r\n    font-size:30px;\r\n  }\r\n  \r\n  .values-row {\r\n      display:flex;\r\n      justify-content: center;\r\n      text-align: center;\r\n      gap: 66px; \r\n      margin-top:12px;\r\n      font-weight: bold;\r\n    \r\n    }\r\n    \r\n    .text-row {\r\n      display: flex;\r\n      gap: 15px; \r\n      margin-top: 3px; \r\n      margin-left: 10px;\r\n    }\r\n    .text-row .co2{\r\n      margin-left: 72px;\r\n    }\r\n    .text-row .ETP{\r\n      margin-left: 34px;\r\n    }\r\n    .EB-image-row {\r\n      display: flex;\r\n      gap: 94px; \r\n      margin-left:20px;\r\n    }\r\n    \r\n    .EB-image-row img {\r\n      width: 78px;\r\n      height: 76px;\r\n      margin-left:14px;\r\n    } \r\n\r\n    .alarm-div{\r\n      margin-top:-11%;\r\n      margin-left: 36%;\r\n      width: 22vw;\r\n      height:18vw;\r\n      \r\n      border-radius: 12px;\r\n      justify-content: center;\r\n      text-align: center;\r\n      \r\n    }\r\n    .alarm-container {\r\n      padding: 15px;\r\n      border: 4px solid #ccc;\r\n      border-radius: 12px;\r\n      \r\n    }\r\n    \r\n   \r\n    .alarm-header h6 {\r\n      font-size: 34px;\r\n      font-weight: bold;\r\n     \r\n    }\r\n    .alarm-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 27px;\r\n    }\r\n    \r\n    .alarm-item {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      padding: 14px;\r\n      border-radius: 8px;\r\n      background-color: white;\r\n      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    }\r\n    \r\n    .alarm-item span {\r\n      font-size: 28px;\r\n      font-weight: bold;\r\n      color: #333;\r\n    }\r\n    \r\n    .alarm-icon {\r\n      width: 18px;\r\n      height: 18px;\r\n      margin-right: 8px;\r\n    }\r\n    .date-picker-container {\r\n      display: flex;\r\n      align-items: center;\r\n      margin: 1rem 0;\r\n  }\r\n  \r\n  .date-picker-label {\r\n      font-weight: bold;\r\n      margin-right: 1rem;\r\n  }\r\n  \r\n  .styled-date-picker {\r\n      padding: 0.8rem 1.3rem;\r\n      font-size: 32px;\r\n      border: 3px solid #ddd;\r\n      border-radius: 10px;\r\n    }\r\n  \r\n  .dropdown-container{\r\n      margin-top: 1px;   \r\n  }\r\n  .styled-dropdown{\r\n      height:70px;\r\n      padding: 0.5rem 1rem;\r\n      font-size: 32px;\r\n      border: 3px solid #ddd;\r\n      border-radius: 8px;\r\n      background-color: white;\r\n      cursor: pointer;\r\n     \r\n  }\r\n  .date-picker-container,\r\n  .dropdown-container {\r\n      display: inline-block;\r\n      margin-right: 10px; \r\n  }\r\n  .energy-value-container {\r\n      gap: 10px; \r\n      margin-top:0.1%;\r\n  }\r\n  \r\n  .energy-value-container h6 {\r\n      margin-left: 10%; \r\n      padding: 1;\r\n      font-size: 33px; \r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 3796px) {\r\n\r\n  .plant-header {\r\n    font-size:62px;\r\n    width: 30vw; \r\n    margin: 15; \r\n} \r\n.main-div {\r\n  padding: 1.6rem; \r\n  width: 35vw;\r\n  margin-top: 0.8%; \r\n  border-radius: 24px;\r\n}\r\n.item {\r\n    background-color: white;\r\n    padding: 2rem; \r\n    text-align: center;\r\n    width: 15vw; \r\n    min-height: 13vh; \r\n    border-radius: 32px;\r\n    font-weight: bold;\r\n    font-size: 52px;\r\n}\r\n  .main-div3 {\r\n      margin-top: -26%; \r\n      width: 47vw; \r\n      \r\n  }\r\n  .flow-diagram{\r\n    margin-top:-14%;\r\n    margin-left: 60%;\r\n    width: 38vw;\r\n    height:20vw;\r\n    background-color: white;\r\n  }\r\n  .env-benefits{\r\n    margin-top:-26%;  \r\n    width: 22vw;\r\n    height:10vw; \r\n    border-radius: 27px;   \r\n     }\r\n  .coal ,.co2, .ETP{\r\n      font-size:37px;\r\n      justify-content: center;\r\n      text-align: center;\r\n  }\r\n  .env-header{\r\n    font-size:44px;\r\n  }\r\n  \r\n  .values-row {\r\n      display:flex;\r\n      justify-content: center;\r\n      text-align: center;\r\n      gap: 85px; \r\n      margin-top:18px;\r\n      font-weight: bold;\r\n    \r\n    }\r\n    \r\n    .text-row {\r\n      display: flex;\r\n      gap: 28px; \r\n      margin-top: 3px; \r\n      margin-left: 10px;\r\n    }\r\n    .text-row .co2{\r\n      margin-left: 100px;\r\n    }\r\n    .text-row .ETP{\r\n      margin-left: 34px;\r\n    }\r\n    .EB-image-row {\r\n      display: flex;\r\n      gap: 140px; \r\n      margin-left:20px;\r\n    }\r\n    \r\n    .EB-image-row img {\r\n      width: 128px;\r\n      height: 116px;\r\n      margin-left:28px;\r\n    } \r\n\r\n    .alarm-div{\r\n      margin-top:-10%;\r\n      margin-left: 36%;\r\n      width: 22vw;\r\n      height:15vw;\r\n      border-radius: 10px;\r\n      justify-content: center;\r\n      text-align: center;\r\n      \r\n    }\r\n    .alarm-container {\r\n      padding: 25px;\r\n      border: 6px solid #ccc;\r\n      border-radius: 15px;\r\n      \r\n    }\r\n    \r\n   \r\n    .alarm-header h6 {\r\n      font-size: 46px;\r\n      font-weight: bold;\r\n     \r\n    }\r\n    .alarm-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 28px;\r\n    }\r\n    \r\n    .alarm-item {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      padding: 30px;\r\n      border-radius: 22px;\r\n      background-color: white;\r\n      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    }\r\n    \r\n    .alarm-item span {\r\n      font-size: 45px;\r\n      font-weight: bold;\r\n      color: #333;\r\n    }\r\n    \r\n    .alarm-icon {\r\n      width: 28px;\r\n      height: 28px;\r\n      margin-right: 10px;\r\n    }\r\n    .date-picker-container {\r\n      display: flex;\r\n      align-items: center;\r\n      margin: 1rem 0;\r\n  }\r\n  \r\n  .date-picker-label {\r\n      font-weight: bold;\r\n      margin-right: 1rem;\r\n  }\r\n  \r\n  .styled-date-picker {\r\n      padding: 1.2rem 1.7rem;\r\n      font-size: 47px;\r\n      border: 5px solid #ddd;\r\n      border-radius: 14px;\r\n    }\r\n  \r\n  .dropdown-container{\r\n      margin-top: 1px;   \r\n  }\r\n  .styled-dropdown{\r\n      height:94px;\r\n      padding: 0.6rem 1.2rem;\r\n      font-size: 48px;\r\n      border: 3px solid #ddd;\r\n      border-radius: 8px;\r\n      background-color: white;\r\n      cursor: pointer;\r\n     \r\n  }\r\n  .date-picker-container,\r\n  .dropdown-container {\r\n      display: inline-block;\r\n      margin-right: 10px; \r\n  }\r\n  .energy-value-container {\r\n      gap: 10px; \r\n      margin-top:0.1%;\r\n  }\r\n  \r\n  .energy-value-container h6 {\r\n      margin-left: 10%; \r\n      padding: 1;\r\n      font-size: 47px; \r\n  }  \r\n}\r\n\r\n\r\n@media only screen and (min-width: 5061px) {\r\n  .plant-header {\r\n    font-size:80px;\r\n    width: 30vw; \r\n    margin: 15; \r\n} \r\n.main-div {\r\n  padding: 1.6rem; \r\n  width: 35vw;\r\n  margin-top: 1%; \r\n  border-radius: 28px;\r\n}\r\n.item {\r\n    background-color: white;\r\n    padding: 2rem; \r\n    text-align: center;\r\n    width: 15vw; \r\n    min-height: 13vh; \r\n    border-radius: 32px;\r\n    font-weight: bold;\r\n    font-size: 70px;\r\n}\r\n\r\n  .main-div3 {\r\n      margin-top: -23.8%; \r\n      width: 47vw; \r\n      height: 300px !important;\r\n      \r\n  }\r\n  .flow-diagram{\r\n    margin-top:-15%;\r\n    margin-left: 60%;\r\n    width: 38vw;\r\n    height:20vw;\r\n    background-color: white;\r\n  }\r\n  .env-benefits{\r\n    margin-top:-28%;  \r\n    width: 22vw;\r\n    height:10vw;   \r\n    border-radius: 34px;  \r\n     }\r\n  .coal ,.co2, .ETP{\r\n      font-size:45px;\r\n      justify-content: center;\r\n      text-align: center;\r\n  }\r\n  .env-header{\r\n    font-size:58px;\r\n    margin:25px;\r\n  }\r\n  \r\n  .values-row {\r\n      display:flex;\r\n      justify-content: center;\r\n      text-align: center;\r\n      gap: 150px; \r\n      margin-top:20px;\r\n      font-weight: bold;\r\n    \r\n    }\r\n    \r\n    .text-row {\r\n      display: flex;\r\n      gap: 38px; \r\n      margin-top: 3px; \r\n      margin-left: 10px;\r\n    }\r\n    .text-row .co2{\r\n      margin-left: 130px;\r\n    }\r\n    .text-row .ETP{\r\n      margin-left: 34px;\r\n    }\r\n    .EB-image-row {\r\n      display: flex;\r\n      gap: 220px; \r\n      margin-left:38px;\r\n    }\r\n    \r\n    .EB-image-row img {\r\n      width: 158px;\r\n      height: 146px;\r\n      margin-left:28px;\r\n    } \r\n\r\n    .alarm-div{\r\n      margin-top:-9%;\r\n      margin-left: 36%;\r\n      width: 22vw;\r\n      height:16vw;\r\n      border-radius: 16px;\r\n      justify-content: center;\r\n      text-align: center;\r\n      \r\n    }\r\n    .alarm-container {\r\n      padding: 40px;\r\n      border: 8px solid #ccc;\r\n      border-radius: 32px;\r\n      \r\n    }\r\n    \r\n   \r\n    .alarm-header h6 {\r\n      font-size: 65px;\r\n      font-weight: bold;\r\n     \r\n    }\r\n    .alarm-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 28px;\r\n    }\r\n    \r\n    .alarm-item {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      padding: 32px;\r\n      border-radius: 18px;\r\n      background-color: white;\r\n      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    }\r\n    \r\n    .alarm-item span {\r\n      font-size: 58px;\r\n      font-weight: bold;\r\n      color: #333;\r\n    }\r\n    \r\n    .alarm-icon {\r\n      width: 38px;\r\n      height: 38px;\r\n      margin-right: 18px;\r\n    }\r\n    .date-picker-container {\r\n      display: flex;\r\n      align-items: center;\r\n      margin: 1rem 0;\r\n  }\r\n  \r\n  .date-picker-label {\r\n      font-weight: bold;\r\n      margin-right: 1rem;\r\n  }\r\n  \r\n  .styled-date-picker {\r\n      padding: 1.3rem 1.8rem;\r\n      font-size: 65px;\r\n      border: 5px solid #ddd;\r\n      border-radius: 14px;\r\n    }\r\n  \r\n  .dropdown-container{\r\n      margin-top: 1px;   \r\n  }\r\n  .styled-dropdown{\r\n      height:125px;\r\n      padding: 0.6rem 1.2rem;\r\n      font-size: 65px;\r\n      border: 3px solid #ddd;\r\n      border-radius: 8px;\r\n      background-color: white;\r\n      cursor: pointer;\r\n     \r\n  }\r\n  .date-picker-container,\r\n  .dropdown-container {\r\n      display: inline-block;\r\n      margin-right: 10px; \r\n  }\r\n  .energy-value-container {\r\n      gap: 10px; \r\n      margin-top:0.1%;\r\n  }\r\n  \r\n  .energy-value-container h6 {\r\n      margin-left: 10%; \r\n      padding: 1;\r\n      font-size: 67px; \r\n  } \r\n\r\n}\r\n\r\n\r\n\r\n\r\n */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
